import * as React from "react";
import {
	Avatar,
	Box,
	Chip,
	Divider,
	Fab,
	Grid,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
	Check,
	CheckCircle,
	ExternalLink,
	Link,
	Link2,
	MapPin,
	User,
} from "react-feather";
import { useNavigate } from "react-router";
import clsx from "clsx";
import moment from "moment";
import StateColumn from "../StateColumn";
import theme from "../../theme";
import State from "../State";

const useStyles = makeStyles((theme) => ({
	wrap: {
		paddingLeft: 10,
		backgroundColor: "white",
		borderRadius: 10,
		borderLeft: "5px solid",
		marginBottom: 20,
	},
	espera: {
		borderColor: "#ababab",
	},
	completada: {
		borderColor: "#8bc34a",
	},
	cancelada: {
		borderColor: "#ff1744",
	},
	pagada: {
		borderColor: "#03a9f4",
	},
}));

export default function LloguerAdmin({ lloguer }) {
	const classes = useStyles();
	const navigate = useNavigate();

	const style =
		lloguer.state.nom === "Pagat"
			? classes.pagada
			: lloguer.state.nom === "Completat"
			? classes.completada
			: lloguer.state.nom === "En espera"
			? classes.espera
			: classes.cancelada;

	return (
		<Box className={clsx(classes.wrap, style)}>
			<Grid container px={1} py={4}>
				<Grid
					item
					xs={2}
					display="flex"
					justifyContent={"center"}
					alignItems="center"
					textAlign={"right"}
				>
					<Box
						borderRight={
							"1px solid " + theme.palette.background.light
						}
						pr={3}
					>
						<Typography variant="h3">
							{moment(lloguer.data).format("D MMM")}
						</Typography>
						<Typography variant="h2">
							{moment(lloguer.data).format("YYYY")}
						</Typography>
					</Box>
				</Grid>
				<Grid item xs={7} display="flex" alignItems={"center"}>
					<Avatar
						src={
							"https://pendolguies.covcontrol.net/public/storage/" +
							lloguer?.materials?.[0].foto
						}
						style={{ width: 50, height: 50 }}
					/>
					<Box ml={2}>
						<Typography>{lloguer?.nom}</Typography>

						<Stack direction="row" spacing={1}>
							{lloguer.materials.map((item) => (
								<Chip size="small" label={item.nom} />
							))}
						</Stack>
					</Box>
				</Grid>
				<Grid item xs={2} display="flex" alignItems={"center"}>
					<State
						state={lloguer.state}
						id={lloguer.id}
						element="lloguers"
					/>
				</Grid>
				<Grid item xs={1} textAlign={"center"}>
					<Fab
						color="primary"
						size="small"
						onClick={() =>
							navigate("/admin/lloguers/view/" + lloguer.id)
						}
					>
						<ExternalLink />
					</Fab>
				</Grid>
			</Grid>
		</Box>
	);
}
